import React from "react";
import {
  PageBuilderLocationSpecificTextBoxesFragment,
  PageBuilderLocationSpecificTextBoxFragment
} from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import { useGeolocation } from "../../utils/localization/geolocation/GeolocationContext";
import { matchesAny } from "../../utils/localization/geolocation";
import { graphql } from "gatsby";
import TextBox from "components/TextBox/TextBox";

const PageBuilderLocationSpecificTextBoxes: React.FC<PageBuilderLocationSpecificTextBoxesFragment> = ({
  heading,
  rows = [],
  boxed = false
}) => {
  const geolocation = useGeolocation();
  const filteredRows = rows.filter(
    (item): item is PageBuilderLocationSpecificTextBoxFragment => {
      if (!item || !item.content) return false;
      return matchesAny(item.locationFilters, geolocation.countryCode);
    }
  );

  if (filteredRows.length == 0) {
    return null;
  }

  return (
    <React.Fragment>
      {heading && <PageBuilderSectionTitle {...heading} />}
      {filteredRows.map((row) => (
        <TextBox
          key={row._key}
          fontSize="medium"
          boxed={boxed}
          content={row.content?.localized}
        />
      ))}
    </React.Fragment>
  );
};

export default PageBuilderLocationSpecificTextBoxes;

export const fragments = graphql`
  fragment PageBuilderLocationSpecificTextBox on SanityLocationSpecificTextBox {
    _key
    content {
      localized
    }

    locationFilters {
      ...AirNonAirOrLocationFilter
    }
  }

  fragment PageBuilderLocationSpecificTextBoxes on SanityLocationSpecificTextBoxes {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    rows {
      ...PageBuilderLocationSpecificTextBox
    }
    boxed
  }
`;
